export default __webpack_public_path__ + "static/media/computer-lab-1.b5ff5e6f.jpg";